import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { View, TouchableOpacity, Keyboard, Platform } from "react-native";
import styles from "./PnmacTabs.styles.js";
var PnmacTabs = /** @class */function (_super) {
  __extends(PnmacTabs, _super);
  function PnmacTabs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {};
    _this.keyboardWillShow = function (e) {
      _this.setState({
        keyboardUp: true
      });
    };
    _this.keyboardWillHide = function (e) {
      _this.setState({
        keyboardUp: false
      });
    };
    return _this;
  }
  PnmacTabs.prototype.onSelect = function (el) {
    if (el.props.onSelect) {
      el.props.onSelect(el);
    } else if (this.props.onSelect) {
      this.props.onSelect(el);
    }
  };
  PnmacTabs.prototype.componentWillMount = function () {
    if (Platform.OS === "android") {
      this.keyboardDidShowListener = Keyboard.addListener("keyboardDidShow", this.keyboardWillShow);
      this.keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", this.keyboardWillHide);
    }
  };
  PnmacTabs.prototype.componentWillUnmount = function () {
    if (this.keyboardDidShowListener) {
      this.keyboardDidShowListener.remove();
    }
    if (this.keyboardDidHideListener) {
      this.keyboardDidHideListener.remove();
    }
  };
  PnmacTabs.prototype.render = function () {
    var _this = this;
    var small = this.props.small;
    var self = this;
    var selected = this.props.selected;
    if (!selected) {
      React.Children.forEach(this.props.children.filter(function (c) {
        return c;
      }), function (el) {
        if (!selected || el.props.initial) {
          selected = el.props.name || el.key;
        }
      });
    }
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.tabbarView, this.props.style, this.state.keyboardUp && styles.hidden],
      testID: "tabs"
    }, React.Children.map(this.props.children.filter(function (c) {
      return c;
    }), function (el) {
      return /*#__PURE__*/React.createElement(TouchableOpacity, {
        key: el.props.name + "touch",
        testID: el.props.testID,
        style: __assign(__assign(__assign({}, styles.iconView), _this.props.iconStyle), (el.props.name || el.key) == selected ? _this.props.selectedIconStyle || el.props.selectedIconStyle || {} : {}),
        onPress: function () {
          return !self.props.locked && self.onSelect(el);
        },
        onLongPress: function () {
          return self.onSelect(el);
        },
        activeOpacity: el.props.pressOpacity
      }, selected == (el.props.name || el.key) ? /*#__PURE__*/React.cloneElement(el, {
        selected: true,
        style: __assign(__assign(__assign({}, el.props.style), _this.props.selectedStyle), el.props.selectedStyle)
      }) : el);
    }));
  };
  return PnmacTabs;
}(Component);
export default PnmacTabs;